export default __webpack_public_path__ + "static/media/weekly-cashback.f6c90106.svg";